// VERA-825: Tag shop checkout hooks.
// Wraps tagShopApi in tanstack-query mutations.

import {useMutation} from '@tanstack/react-query';
import {
  tagShopApi,
  TagShopCalculateResult,
  TagShopLineItem,
  TagShopPaymentIntentResult,
  TagShopShippingAddress,
} from 'services/tagShopApi';

export type {
  TagShopCalculateResult,
  TagShopLineItem,
  TagShopPaymentIntentResult,
  TagShopShippingAddress,
};
export type {TagShopShippingRate} from 'services/tagShopApi';

/**
 * Calls the calculate endpoint to get Shopify-authoritative tax + shipping
 * rates for a given address + item set.
 */
export const useTagShopCalculate = () =>
  useMutation<
    TagShopCalculateResult,
    Error,
    {
      companyId: string;
      items: TagShopLineItem[];
      shippingAddress: TagShopShippingAddress;
    }
  >({
    mutationFn: (params) => tagShopApi.calculate(params),
  });

/**
 * Creates the Stripe PaymentIntent for the tag shop order.
 * Must be called with the chosen shipping rate handle after the user fills in
 * their address and selects a shipping option.
 */
export const useTagShopCreatePaymentIntent = () =>
  useMutation<
    TagShopPaymentIntentResult,
    Error,
    {
      companyId: string;
      items: TagShopLineItem[];
      shippingAddress: TagShopShippingAddress;
      shippingRateHandle: string;
    }
  >({
    mutationFn: (params) => tagShopApi.createPaymentIntent(params),
  });
